import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface HeaderNotification {
  id: string;
  title: string;
  message: string;
  link: string;
  is_read: boolean;
  created_at: string;
}

export interface HeaderNotificationsResponse {
  unread_count: number;
  results: HeaderNotification[];
}

@Injectable({ providedIn: 'root' })
export class HeaderNotificationService {
  constructor(private readonly http: HttpClient) {}

  list(): Observable<HeaderNotificationsResponse> {
    return this.http.get<HeaderNotificationsResponse>(`${environment.apiUrl}/auth/notifications/`);
  }

  markRead(notificationId: string): Observable<{ updated: number }> {
    return this.http.post<{ updated: number }>(`${environment.apiUrl}/auth/notifications/read/`, {
      notification_id: notificationId,
    });
  }

  markAllRead(): Observable<{ updated: number }> {
    return this.http.post<{ updated: number }>(`${environment.apiUrl}/auth/notifications/read/`, {
      mark_all: true,
    });
  }
}
